"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("@flowio/events");
var browser_helpers_1 = require("@flowio/browser-helpers");
var types_1 = require("../types");
var SnapchatPixel = /** @class */ (function () {
    function SnapchatPixel(options) {
        var defaultOpts = {
            useBaseCurrency: true,
        };
        var opts = __assign(__assign({}, defaultOpts), options);
        this.useBaseCurrency = opts.useBaseCurrency;
        this.customAttributes = opts.customAttributes;
        var events = new events_1.ChannelEventEmitter();
        events.trigger('pixelSCReady');
    }
    SnapchatPixel.test = function (global) {
        if (global === void 0) { global = window; }
        return (typeof global.snaptr === 'function');
    };
    SnapchatPixel.configureTrackers = function (trackers) {
        trackers.forEach(function (tracker) {
            snaptr('init', tracker.tracker_id);
        });
    };
    /**
     * Load and configure Snapchat pixel if not already loaded.
     */
    SnapchatPixel.install = function (configuration) {
        var trackers = configuration.trackers;
        // Bail to avoid polluting global scope
        if (!trackers.length) {
            return;
        }
        if (SnapchatPixel.test()) {
            SnapchatPixel.configureTrackers(trackers);
            return;
        }
        var snaptr = window.snaptr = function () {
            snaptr.handleRequest
                ? snaptr.handleRequest.apply(snaptr, arguments)
                : snaptr.queue.push(arguments);
        };
        snaptr.queue = [];
        SnapchatPixel.configureTrackers(trackers);
        browser_helpers_1.loadScript('https://sc-static.net/scevent.min.js', {
            async: true,
        });
    };
    SnapchatPixel.prototype.fireEvent = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var snaptr = window.snaptr;
        if (typeof snaptr === 'function') {
            snaptr.apply(void 0, args);
        }
    };
    SnapchatPixel.prototype.buildIdArrayFromOrder = function (order) {
        return order.items.map(function (item) { return item.number; });
    };
    SnapchatPixel.prototype.fireAddToCart = function (item) {
        var itemCurrency = item.currency;
        var itemPrice = item.price;
        if (this.useBaseCurrency && item.base_currency != null && item.base_price != null) {
            itemCurrency = item.base_currency;
            itemPrice = item.base_price;
        }
        var data = {
            content_ids: [item.id],
            content_name: item.name,
            content_type: 'product_group',
            contents: [{
                    id: item.id,
                    quantity: item.quantity,
                    item_priceb: itemPrice,
                }],
            currency: itemCurrency,
            value: item.quantity * itemPrice,
        };
        this.fireEvent('track', 'AddToCart', data);
    };
    SnapchatPixel.prototype.fireInitiateCheckoutStep = function () {
        this.fireEvent('track', 'START_CHECKOUT');
    };
    SnapchatPixel.prototype.firePurchase = function (order) {
        var contents = order.items.map(function (item) {
            var id = item.number;
            return id;
        });
        var data = {
            price: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            currency: this.useBaseCurrency ? order.total.base.currency : order.total.currency,
            transaction_id: order.number,
            item_ids: contents,
            number_items: order.items.length,
        };
        this.fireEvent('track', 'PURCHASE', data);
    };
    SnapchatPixel.prototype.fireContentView = function (value) {
        this.fireEvent('track', 'PAGE_VIEW', value);
    };
    SnapchatPixel.prototype.event = function (event) {
        switch (event.type) {
            case types_1.PixelEventType.Purchase:
            case types_1.PixelEventType.Transaction:
                this.firePurchase(event.data.order);
                break;
            case types_1.PixelEventType.CheckoutInit:
                this.fireInitiateCheckoutStep();
                break;
            case types_1.PixelEventType.PageView:
                this.fireContentView(event.data.value);
                break;
            case types_1.PixelEventType.AddToCart:
                this.fireAddToCart(event.data.item);
                break;
            default:
                break;
        }
    };
    return SnapchatPixel;
}());
exports.default = SnapchatPixel;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/snap/snapPixel.js
// module id = 614
// module chunks = 0 1